'use strict';

/**
 * @abstract
 */
ngtk.model.Abstract = Class({

    _scope: null,

    wireScope: function(scope, path) {
        this._scope = scope;
        var ptr = scope;
        if (!angular.isArray(path)) {
            path = ('' + path).split('.').filter(function(v) {
                return v.length > 0;
            });
        }
        for (var i = 0; i < path.length - 1; ++i) {
            var element = path[i];
            if (angular.isUndefined(ptr[element])) {
                ptr[element] = {};
            }
            ptr = ptr[element];
        }
        element = path[path.length - 1];
        this._wireScope(scope, ptr, element);
        return this;
    },

    _wireScope: function(scope, scopeInnerPtr, scopeInnerElement) {
        Class.abstractMethod();
    },

    _triggerChanged: function() {
        if (this._scope) {
            this._scope.$digest();
        }
    }

});
